import { FeatureFlagName } from "utils/constants/featureFlags.constants";
import { getIsFeatureOn } from "../components/common/Auth/accessChecks";
import { useFeatureFlags } from "../context/FeatureFlagsContext";

export default function useIsFeatureFlagOn(featureFlag: FeatureFlagName) {
  const featureFlags = useFeatureFlags();

  return getIsFeatureOn(featureFlag)({ featureFlags });
}
